export default () =>
  import(
    /* webpackChunkName: 'coffee/app/download/coffee-normal' */ './Normal'
  );
